/* @flow */

import React from 'react';

import { Route, IndexRoute } from 'react-router';
import { loadRoute, render, ViewerQueries } from 'depop/router';

export default (
  <Route path="events">
    <IndexRoute getComponent={(location, cb) => loadRoute(import('./views/Events'), cb)} queries={ViewerQueries} render={render} />
  </Route>
);



// WEBPACK FOOTER //
// ../src/client/apps/events/index.js